import React from "react";
import { useScrollReveal } from "../hooks/useScrollReveal";
import { Award, MapPin, ShieldCheck, Leaf } from "lucide-react";

const stats = [
  {
    icon: Award,
    value: "3",
    label: "Premium Grades",
    sublabel: "4 Suta | 5 Suta | 6 Suta",
  },
  {
    icon: MapPin,
    value: "10+",
    label: "States Served",
    sublabel: "Pan India Delivery",
  },
  {
    icon: ShieldCheck,
    value: "100%",
    label: "Quality Guaranteed",
    sublabel: "Full Lot Replacement",
  },
  {
    icon: Leaf,
    value: "Direct",
    label: "From Bihar Farms",
    sublabel: "Zero Middlemen",
  },
];

const StatsSection = () => {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section
      id="stats"
      ref={ref}
      className="bg-[#0A0A0A] py-16 border-y border-[#D4AF37]/10"
      data-testid="stats-section"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {stats.map((stat, i) => {
            const Icon = stat.icon;
            return (
              <div
                key={stat.label}
                className="text-center p-6 rounded-2xl border border-white/5 bg-[#121212] hover:border-[#D4AF37]/30 transition-all duration-500 hover:shadow-[0_8px_30px_rgba(212,175,55,0.1)] group cursor-default"
                style={{
                  opacity: isVisible ? 1 : 0,
                  transform: isVisible ? "translateY(0)" : "translateY(30px)",
                  transition: `opacity 0.6s ease ${i * 0.1}s, transform 0.6s ease ${i * 0.1}s`,
                }}
                data-testid={`stat-card-${i}`}
              >
                <div className="flex justify-center mb-4">
                  <div className="p-3 rounded-full bg-[#D4AF37]/10 group-hover:bg-[#D4AF37]/20 transition-colors duration-300">
                    <Icon className="text-[#D4AF37]" size={22} />
                  </div>
                </div>
                <div
                  className="text-3xl md:text-4xl font-bold text-[#D4AF37] mb-1"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                  data-testid={`stat-value-${i}`}
                >
                  {stat.value}
                </div>
                <div className="text-[#FAFAFA] font-semibold text-sm mb-1">
                  {stat.label}
                </div>
                <div className="text-[#525252] text-xs">{stat.sublabel}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
